/**
 * A set of errors that need translating before they reach the user.
 */
export enum AmplifyError {
    NotAuthorizedException = "NotAuthorizedException",
    UserNotFoundException = "UserNotFoundException",
    InvalidPasswordException = "InvalidPasswordException",
    CodeMismatchException = "CodeMismatchException",
    ExpiredCodeException = "ExpiredCodeException",
    LimitExceededException = "LimitExceededException",
}

/**
 * A set of user-friendly errors.
 */
export enum ErrorMessage {
    InvalidUsername = "No account found for that username",
    InvalidLoginCredentials = "Invalid username or password",
    InvalidChangePasswordCredentials = "Password reset failed",
    InvalidNewPassword = "Password does not meet requirements",
    PasswordsMismatch = "Passwords do not match",
    NewPasswordRequired = "Please set a new password to continue",
    SessionExpired = "Your session has expired. Please log in again",
    InvalidVerificationCode = "Invalid verification code",
    ExpiredVerificationCode = "Verification code has expired. Please request a new one",
    TooManyAttempts = "Too many attempts. Please try again later",
    Default = "Something went wrong",
}
